import { AlertTriangle } from "@hugeicons-pro/core-duotone-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { type ErrorComponentProps, Link, useCanGoBack, useRouter } from "@tanstack/react-router";
import { Button } from "~/components/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "~/components/ui/empty";
import { SessionExpiredForm } from "~/components/views/auth/session-expired-form";
import { isTRPCClientError } from "~/trpc/client";

export function ErrorComponent({ error }: ErrorComponentProps) {
	const router = useRouter();
	const canGoBack = useCanGoBack();

	if (isTRPCClientError(error)) {
		if (error.data?.code === "UNAUTHORIZED") {
			return (
				<div className="flex min-h-svh min-w-0 flex-1 flex-col items-center justify-center gap-6 p-4">
					<div className="justify-center-center relative mx-auto flex w-full max-w-md flex-col gap-6">
						<SessionExpiredForm />
					</div>
				</div>
			);
		}
	}

	return (
		<div className="flex flex-1 items-center justify-center p-4">
			<Empty className="w-full">
				<EmptyHeader>
					<EmptyMedia variant="icon" className="bg-destructive/5 text-destructive">
						<HugeiconsIcon icon={AlertTriangle} />
					</EmptyMedia>
					<EmptyTitle>An error occured</EmptyTitle>
					<EmptyDescription>
						An error occurred while loading the requested resource. Please try again later.
					</EmptyDescription>
					{error.message && <EmptyDescription>{error.message}</EmptyDescription>}
				</EmptyHeader>
				<EmptyContent className="flex-row justify-center">
					<Button variant="outline" size="sm" onClick={() => router.invalidate()}>
						Try Again
					</Button>
					{canGoBack ? (
						<Button variant="outline" size="sm" onClick={() => router.history.back()}>
							Back
						</Button>
					) : null}
					<Button variant="outline" size="sm" asChild>
						<Link to="/">Go to homepage</Link>
					</Button>
				</EmptyContent>
			</Empty>
		</div>
	);
}
